import { createSlice } from "@reduxjs/toolkit";
import { ApiCallStatus, ApiResourceState, ResourceList } from "@myRedux/networkState";
import { RootState } from "@myRedux/store";
import { handleSliceRejectionDefault } from "@myRedux/handleSliceRejection";
import { SchoolDistrictResource } from "@myRedux/schoolDistrict/schoolDistrictSlice";
import { pagingAsyncThunk, searchAsyncThunk, windowUrlResourceCallAsyncThunk } from "@myRedux/appAsyncThunkUtilities";
import { TeacherResource } from "./teacher";

const initialState = {
  status: ApiCallStatus.Idle,
  value: null
} as ApiResourceState<ResourceList<TeacherResource>>;

export const searchTeachersAsync = searchAsyncThunk<SchoolDistrictResource>('teacher/searchTeachers', 'teachers', 'lastname', 'page');

export const pagingTeachersAsync = pagingAsyncThunk<TeacherResource>('teacher/pageTeachers');

export const getTeacherAsync = windowUrlResourceCallAsyncThunk<TeacherResource>('teacher/getTeacher');

export const teacherSlice = createSlice({
  name: 'teacherSlice',
  initialState: initialState,
  reducers: {
    clearTeachers(state) {
      state.status = ApiCallStatus.Idle;
      state.value = null;
    },
    selectAutocompleteTeacher(state, action) {
      state.status = ApiCallStatus.Succeeded;
      state.value = {
        resources: [action.payload],
        links: []
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchTeachersAsync.pending, (state) => {
        state.status = ApiCallStatus.Loading;
      })
      .addCase(searchTeachersAsync.fulfilled, (state, action) => {
        state.status = ApiCallStatus.Succeeded;
        state.value = action.payload;
      })
      .addCase(searchTeachersAsync.rejected, (state, action) => {
        state.status = ApiCallStatus.Failed;
        state.value = null;
        handleSliceRejectionDefault(action);
      })
      .addCase(pagingTeachersAsync.pending, (state) => {
        state.status = ApiCallStatus.Loading;
      })
      .addCase(pagingTeachersAsync.fulfilled, (state, action) => {
        state.status = ApiCallStatus.Succeeded;
        state.value = action.payload;
      })
      .addCase(pagingTeachersAsync.rejected, (state, action) => {
        state.status = ApiCallStatus.Failed;
        state.value = null;
        handleSliceRejectionDefault(action);
      })
      .addCase(getTeacherAsync.pending, (state) => {
        state.status = ApiCallStatus.Loading;
      })
      .addCase(getTeacherAsync.fulfilled, (state, action) => {
        state.status = ApiCallStatus.Succeeded;
        state.value = {
          resources: [action.payload],
          links: []
        } 
      })
      .addCase(getTeacherAsync.rejected, (state, action) => {
        state.status = ApiCallStatus.Failed;
        state.value = null;
        handleSliceRejectionDefault(action);
      });
  },
});

export const selectTeachers = (state: RootState) => state.teacher.teachers;

const { actions, reducer } = teacherSlice;
export const { clearTeachers, selectAutocompleteTeacher } = actions;
export default reducer;